export default __webpack_public_path__ + "static/media/trophyRewardUnlock.3aebd2ed.png";